import React from 'react';
import { observer } from 'mobx-react';
import { Person } from '@material-ui/icons';

import './css/BroadcastChatHeader.css';
import { RootStoreContext } from '../../../context';


class BroadcastChatHeader extends React.Component {
  static contextType = RootStoreContext;

  onTipButtonClick = () => {
    const { anchor, secondAnchorToTip } = this.props;
    const { tippingStore } = this.context;

    tippingStore.setTippingModal({
      name: anchor.name,
      username: anchor.username,
      id: anchor.id,
    },
    secondAnchorToTip.username,
    secondAnchorToTip.nickname);
  };

  render() {
    const {
      roomCount,
      isAnchor,
      isAuthentified,
      isBanned,
      isInGroupShow,
      showTipBtnForGroupShow,
    } = this.props;

    return (
      <div className="broadcast-chat-header">
        {(!isAnchor && isAuthentified) && !isBanned && (!isInGroupShow || (isInGroupShow && showTipBtnForGroupShow)) &&
        <button
          className="btn btn-red tipping-btn"
          onClick={this.onTipButtonClick}
        >TIP $
        </button>
        }
        <span className="user-count">
          <Person />
          <span>{roomCount}</span>
        </span>
      </div>
    );
  }
}

export default observer(BroadcastChatHeader);
